// Admin.jsx
//
// NOTE: this password check is a cosmetic gate, NOT a security boundary.
// Vite inlines every VITE_* variable into the JS bundle at build time, so this
// value is readable by anyone who opens devtools. Any real admin capability
// must be gated server-side. See issue #11.
import { useState } from 'react';
import Sidebar from '../components/Sidebar';

const ADMIN_PASSWORD = import.meta.env.VITE_ADMIN_PASSWORD;

const Admin = () => {
  const [access, setAccess] = useState(false);
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();

    // Without a configured password there is nothing to compare against, so
    // deny rather than letting an empty input match an undefined value.
    if (!ADMIN_PASSWORD) {
      setError('Admin access is not configured on this build.');
      return;
    }

    if (input === ADMIN_PASSWORD) {
      setAccess(true);
      setError('');
    } else {
      setError('Incorrect password.');
    }
  };

  if (!access) {
    return (
      <div className="content">
        <Sidebar />
        <div className="main-content">
          <h1>Admin</h1>
          {ADMIN_PASSWORD ? (
            <form onSubmit={handleLogin}>
              <label htmlFor="admin-password">Enter the admin password</label>
              <input
                id="admin-password"
                type="password"
                value={input}
                onChange={(e) => setInput(e.target.value)}
              />
              <button type="submit">Log in</button>
            </form>
          ) : (
            <p>Admin access is not configured on this build.</p>
          )}
          {error && <p role="alert">{error}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="content">
      <Sidebar />
      <div className="main-content">
        <h1>Admin Panel</h1>
        <p>Manage server settings and user data.</p>
      </div>
    </div>
  );
};

export default Admin;
